import { render, staticRenderFns } from "./StallManagement.vue?vue&type=template&id=6ba5c52e&scoped=true"
import script from "./StallManagement.vue?vue&type=script&lang=js"
export * from "./StallManagement.vue?vue&type=script&lang=js"
import style0 from "./StallManagement.vue?vue&type=style&index=0&id=6ba5c52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba5c52e",
  null
  
)

export default component.exports